import React from 'react';
import { Check, CheckCircle, Circle } from 'lucide-react';

const PasswordCriteria = ({ password }) => {
  const criteria = [
    {
      label: "Password must be at least 8 characters long",
      met: password.length >= 8,
    },
    {
      label: "Password must contain 1 Uppercase & 1 Lowercase letter",
      met: /[A-Z]/.test(password) && /[a-z]/.test(password),
    },
    {
      label: "Password must contain at least one digit like 1,2,3,4,5,6,etc.",
      met: /\d/.test(password),
    },
    {
      label: "Password must contain at least one special character like !, @, #, $, etc.",
      met: /[^A-Za-z0-9]/.test(password),
    },
  ];

  // Sequential validation logic
  // let canValidate = true;

  return (
    <ul className='-mt-2 flex flex-col gap-1 space-y-1' aria-label="Password requirements">
      {criteria.map((item, index) => {
        // Only validate the current item if all previous ones are met
        // const shouldValidate = canValidate && item.met;
        // if (!item.met) canValidate = false;

        return (
          <li key={index} className='flex items-center text-xs'>
            {item.met ? (
              <div className='rounded-full bg-green-500 p-1 mr-2'>
                <Check className='size-3 text-white' />

              </div>
            ) : (
              <Circle className='size-2 text-[#34416D] mr-2' />
            )}
            <span className={`${item.met ? "text-green-700 text-sm": "text-slate-700"} `}>{item.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

const PasswordStrengthMeter = ({ password }) => {
  return (
    <div className='mt-8'>
      <PasswordCriteria password={password} />
    </div>
  );
};

export default PasswordStrengthMeter;
